<template>
    <div>
        <div class="Keikakumeisai_HanbaisakiCostItem Keikakumeisai_TotalCostSubHead"><div>{{this.CostName}}</div> <div class="Keikakumeisai_TotalCostSubValue">{{ this.$FormatCurrency(this.Cost) }}</div></div>
    </div>
</template>

<script>
export default
{
    props:{
        CostName: String,
        Cost: Number
    }
}
</script>